import script from "./SearchBox2.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBox2.vue?vue&type=script&setup=true&lang=js"

import "./SearchBox2.vue?vue&type=style&index=0&id=dd8f3fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd8f3fcc"]])

export default __exports__